import { Component, OnInit, Inject, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'psnb-mobile-power-supply-telemetry-psScoredialog',
  templateUrl: './power-supply-telementrydata-psScore-dialog.component.html',
  styleUrls: ['./power-supply-telementrydata-psScore-dialog.component.scss']
})
export class PowerSupplyTelemetryPsScoredialogComponent implements OnInit {
  messages: string[];

  constructor(
    public dialogRef: MatDialogRef<PowerSupplyTelemetryPsScoredialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data) { }

  ngOnInit(): void {
    if(this.data.message) {
      this.messages = this.data.message.split(',');
    } else {
      this.messages = ['PS Score Details: -'];
    }
  }

}